import { render, staticRenderFns } from "./WorksMerge.vue?vue&type=template&id=6abb2dc1&scoped=true&"
import script from "./WorksMerge.vue?vue&type=script&lang=js&"
export * from "./WorksMerge.vue?vue&type=script&lang=js&"
import style0 from "./WorksMerge.vue?vue&type=style&index=0&id=6abb2dc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abb2dc1",
  null
  
)

export default component.exports